import type { Editor } from 'slate';

export const EDITOR_TO_LOCAL_CHANGES_IN_SLATE_TICK = new WeakMap<Editor, boolean>();
